module.exports = __webpack_public_path__ + "static/04-d0bc32c1bf12d63e09e333118192d32e.jpg";